import { useMutation } from '@tanstack/react-query';
import { VirtualMedicine } from '../types';
import { createVirtualMedicine } from '../requests';

type CreateVirtualMedicine = (data: VirtualMedicine) => Promise<VirtualMedicine>;

interface UseCreateVirtualMedicineReturn {
  createVirtualMedicine: CreateVirtualMedicine;
  isLoading: boolean;
}

export const useCreateVirtualMedicine = (): UseCreateVirtualMedicineReturn => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (virtualMedicine: VirtualMedicine) => createVirtualMedicine(virtualMedicine)
  });

  const createVirtualMedicineCallback = async (virtualMedicine: VirtualMedicine) => {
    const response = await mutateAsync(virtualMedicine);
    return response.data.data;
  };

  return {
    createVirtualMedicine: createVirtualMedicineCallback,
    isLoading
  };
};
